import Home from '../pages/Home.svelte';
import CreateDeposit from '../pages/CreateDeposit.svelte';
export const routes = {
    '/': Home,
    '/createdeposit': CreateDeposit,
};
